import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import { IDonorSearchState, IDonorSearchResponse, IApplicationState, AppActionCreators, DonorSearchActionCreators, IFindDashResponse, IFindDonorResponse, ICreateResponse, IExistsByAliasResponse, ILookupDataResponse, IFindDsdResponse } from '@nkr/store/index';
import { IDonorSearchResult, IBaseResponse, IClosedLoopCreateLinks, ICenter, IListItem } from '@nkr/models/index';
import { ClosedLoopAssignType, DonorShieldStatus, OrganType } from '@nkr/enums/index';
import { DonorSearchProvider } from './context';
import { toast } from 'react-toastify';
import Filters from './filters';
import List from './list';
import FindDash from './modals/find-dash';
import FindDonor from './modals/find-donor';
import Create from './modals/create';
import { YesNoUnknown } from '@nkr/enums/yes-no-unknown';
import { AxiosError } from 'axios';
import { Alert } from 'react-bootstrap';
import MarkDonated from './modals/mark-donated';
import FindDsd from './modals/find-dsd';

interface IOwnProps {
    centerId: number
}

interface IStateProps {
    center: ICenter,
    donorSearch: IDonorSearchState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    doSearch: (centerId: number, firstName: string, lastName: string, alias: string, email: string, dateOfBirth: string) => Promise<IDonorSearchResponse>,
    doCreate: (
        centerId: number, identifier: string,
        registrationId: number, donorId: number, donorShieldDirectId: number, watrRequestId: number, donorFollowUpId: number,
        links: IClosedLoopCreateLinks, firstName: string, lastName: string, address: string, city: string, state: string, postalCode: string, phone: string, email: string,
        birthDate: string, registrationDate: string, donationDate: string, donationType: number, alias: string, hasNutcracker: YesNoUnknown, sendInvite: boolean) => Promise<ICreateResponse>,
    doFindDash: (centerId: number, search: string) => Promise<IFindDashResponse>,
    doFindDonor: (centerId: number, search: string) => Promise<IFindDonorResponse>,
    doFindDsd: (centerId: number, search: string) => Promise<IFindDsdResponse>,
    doAssign: (item: IDonorSearchResult, type: ClosedLoopAssignType) => Promise<IBaseResponse>,
    existsByAlias: (centerId: number, alias: string) => Promise<IExistsByAliasResponse>,
    markDonated: (identifier: string, dashRegistrationId: number, donationDate: string, donationType: number) => Promise<IBaseResponse>,
    getLookupData: (centerId: number) => Promise<ILookupDataResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    showDashSearch: boolean,
    showFindDonor: boolean,
    showFindDsd: boolean,
    selectedIndex: number,
    search: string,
    filtered: boolean,
    create: {
        show: boolean,
        type: ClosedLoopAssignType,
        firstName: string,
        lastName: string,
        birthDate: string,
        registrationDate: string,
        hasNutcracker: YesNoUnknown
    },
    markDonated: {
        show: boolean,
        data: IDonorSearchResult
    },
    closeLoopManualConfirmTypes: IListItem[],
    donationTypes: IListItem[],
    allowVoucherSelfRegistration: boolean
}

class DonorSearch extends React.Component<TProps, IState> {
    readonly state: IState = {
        showDashSearch: false,
        showFindDonor: false,
        showFindDsd: false,
        selectedIndex: -1,
        search: '',
        filtered: false,
        create: {
            show: false,
            type: ClosedLoopAssignType.DASH,
            firstName: '',
            lastName: '',
            birthDate: '',
            registrationDate: '',
            hasNutcracker: YesNoUnknown.Unknown
        },
        markDonated: {
            show: false,
            data: null
        },
        closeLoopManualConfirmTypes: [],
        donationTypes: [],
        allowVoucherSelfRegistration: false
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting ready, one moment please...').then(() => {
            this.props.getLookupData(this.props.centerId).then(response => {
                let { closedLoopManualConfirmTypes: closeLoopManualConfirmTypes, donationTypes, allowVoucherSelfRegistration } = response.data.results;

                this.setState({
                    closeLoopManualConfirmTypes,
                    donationTypes,
                    allowVoucherSelfRegistration
                });

                this.props.hideLoading();
            });
        });
    }

    handleSearch = (firstName: string, lastName: string, alias: string, email: string, dateOfBirth: string) => {
        this.props.showLoading("Searching, one moment please...").then(() => {
            this.props.doSearch(this.props.centerId, firstName, lastName, alias, email, dateOfBirth)
                .then(response => {
                    this.setState({
                        selectedIndex: -1,
                        filtered: firstName != '' || lastName != '' || alias != '' || email != '' || dateOfBirth != ''
                    }, () => {
                        this.props.hideLoading();
                    });
                })
                .catch(error=> {
                    console.log(error.response.data);
                    this.props.hideLoading();
                })
                ;
        })
    }

    handleExpand = (index: number) => {
        let selectedItem = this.getSortedResults()[index];

        this.setState({
            selectedIndex: this.state.selectedIndex != index ? index : -1,
            search: selectedItem ? `${selectedItem.firstName} ${selectedItem.lastName}` : ''
        });
    }

    handleDisplayCreate = (type: ClosedLoopAssignType) => {
        this.setState({
            create: { ...this.state.create, show: true, type }
        });
    }

    handleCreate = async (
        links: IClosedLoopCreateLinks,
        firstName: string,
        lastName: string,
        address: string,
        city: string,
        state: string,
        postalCode: string,
        phone: string,
        email: string,
        birthDate: string,
        registrationDate: string,
        donationDate: string,
        donationType: number,
        alias: string,
        hasNutcracker: YesNoUnknown,
        sendInvite: boolean
    ): Promise<string[]> => {
        let selectedItem = this.getSortedResults()[this.state.selectedIndex];
        let { registrationId, donorId, donorShieldDirectId, watrRequestId, followUpDonorId, identifier } = selectedItem;

        await this.props.showLoading('Creating linked records, one moment please...');

        return this.props.doCreate(
            this.props.centerId, identifier, registrationId, donorId, donorShieldDirectId, watrRequestId, followUpDonorId,
            links, firstName, lastName, address, city, state, postalCode, phone, email, birthDate, registrationDate, donationDate,
            donationType, alias, hasNutcracker, sendInvite
        )
            .then(response => {
                if (response.data.success) {
                    this.setState({
                        create: { ...this.state.create, show: false }
                    }, () => {
                        if (response.data.success) {
                            toast.success('Linked records created successfully');
                        }

                        this.props.hideLoading();
                    });

                    return Promise.resolve([]);
                } else {
                    this.props.hideLoading();
                    return Promise.resolve(response.data.messages);
                }
            })
            .catch((error: AxiosError) => {
                toast.error(
                    <>
                        <div>Unable to create linked records:</div>
                        <div>{error.message}</div>
                    </>
                );

                this.props.hideLoading();

                return Promise.resolve([]);
            });
    }

    handleCancelCreate = () => {
        this.setState({
            create: { ...this.state.create, show: false }
        });
    }

    handleDisplayDashSearch = () => {
        this.setState({
            showDashSearch: true
        });
    }

    handleCancelDashSearch = () => {
        this.setState({
            showDashSearch: false
        });
    }

    handleDisplayFindDonor = () => {
        this.setState({
            showFindDonor: true
        });
    }

    handleCancelFindDonor = () => {
        this.setState({
            showFindDonor: false
        });
    }

    handleDisplayFindDsd = () => {
        this.setState({
            showFindDsd: true
        });
    }

    handleCancelFindDsd = () => {
        this.setState({
            showFindDsd: false
        });
    }

    handleAssign = (id: number, type: ClosedLoopAssignType) => {
        let list = this.getSortedResults();
        let item = list[this.state.selectedIndex];
        let typeDescription = '';

        if (type == ClosedLoopAssignType.DASH) {
            item.registrationId = id;
            typeDescription = 'DASH';
        }

        if (type == ClosedLoopAssignType.Donor) {
            item.donorId = id;
            typeDescription = 'Donor';
        }

        if (type == ClosedLoopAssignType.DonorShieldDirect) {
            item.donorShieldDirectId = id;
            typeDescription = 'DSD';
        }

        this.props.showLoading('Assigning selected ' + typeDescription + ' record, one moment please...').then(() => {
            this.props.doAssign(item, type).then(response => {
                this.setState({
                    create: { ...this.state.create, show: false },
                    showDashSearch: false,
                    showFindDonor: false,
                    showFindDsd: false
                }, () => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        let message = '';

                        switch (type) {
                            case ClosedLoopAssignType.DASH:
                                message = 'DASH record assigned successfully...';
                                break;

                            case ClosedLoopAssignType.Donor:
                                message = 'Donor record assigned successfully...';
                                break;

                            case ClosedLoopAssignType.DonorShieldDirect:
                                message = 'DSD record assigned successfully...';
                                break;
                        }

                        toast.success(message);
                    }
                });
            });
        });
    }

    handleExistsByAlias = (alias: string) => {
        return this.props.showLoading('Validating donor alias, one moment please...').then(() => {
            return this.props.existsByAlias(this.props.centerId, alias)
                .then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        return Promise.resolve(response.data.results);
                    } else {
                        return Promise.resolve(0);
                    }
                })
                .catch(() => {
                    this.props.hideLoading();
                    return Promise.resolve(-1);
                });
        });
    }

    handleShowMarkDonated = (identifier: string) => {
        let data = this.getSortedResults().find(x => x.identifier == identifier);

        this.setState({
            markDonated: {
                show: true,
                data
            }
        });
    }

    handleCancelMarkDonated = () => {
        this.setState({
            markDonated: {
                show: false,
                data: null
            }
        });
    }

    handleMarkDonated = (donationDate: string, closeType: number) => {
        let { identifier, registrationId } = this.state.markDonated.data;

        this.setState({
            markDonated: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating record, one moment please...').then(() => {
                this.props.markDonated(identifier, registrationId, donationDate, closeType).then(response => {
                    if (response.data.success) {
                        toast.success('Record updated successfully');
                    }

                    this.props.hideLoading();
                });
            });
        });
    }

    getSortedResults = () => {
        const { dashResults, donorResults, donorShieldDirectResults, followUpDonorResults } = this.props.donorSearch.searchResults
        const all = [...dashResults, ...donorResults, ...donorShieldDirectResults, ...followUpDonorResults];
console.log(dashResults);
        const list = _.orderBy(all, [(item) => {
            return new Date(item.registrationDate);
        }, (item) => item.lastName, (item) => item.firstName], ['desc', 'asc', 'asc']);

        return list;
    }

    render = () => {
        const list = this.getSortedResults();
        const selectedItem = list[this.state.selectedIndex];
        const isInDonorShield = this.props.center.isInDonorShield == DonorShieldStatus.On || this.props.center.isInDonorShield == DonorShieldStatus.Pilot;

        return (
            <>
                <DonorSearchProvider value={{
                    centerId: this.props.centerId,
                    selectedIndex: this.state.selectedIndex,
                    doExpand: this.handleExpand,
                    doDisplayCreate: this.handleDisplayCreate,
                    doDisplayDashSearch: this.handleDisplayDashSearch,
                    doDisplayFindDonor: this.handleDisplayFindDonor,
                    doDisplayFindDsd: this.handleDisplayFindDsd,
                    doMarkDonated: this.handleShowMarkDonated
                }}>
                    <Filters onSearch={this.handleSearch} />

                    {this.state.filtered == false && list.length > 0 && (
                        <Alert bsStyle='info' bsSize='sm'>
                            Without a filter, the following are the most recent 100 DASH registrations...
                        </Alert>
                    )}

                    <List
                        data={list}
                        isInDonorShield={isInDonorShield}
                        filtered={this.state.filtered}
                    />

                    <Create
                        show={this.state.create.show}
                        type={this.state.create.type}
                        data={selectedItem}
                        isInDonorShield={isInDonorShield}
                        donationTypes={this.state.donationTypes}
                        allowVoucherSelfRegistration={this.state.allowVoucherSelfRegistration}
                        onCheckExistingDonor={this.handleExistsByAlias}
                        onCreate={this.handleCreate}
                        onCancel={this.handleCancelCreate}
                    />

                    <FindDash
                        show={this.state.showDashSearch}
                        centerId={this.props.centerId}
                        search={this.state.search}
                        onSearch={this.props.doFindDash}
                        onAssign={this.handleAssign}
                        onCancel={this.handleCancelDashSearch}
                    />

                    <FindDonor
                        show={this.state.showFindDonor}
                        centerId={this.props.centerId}
                        search={this.state.search}
                        onSearch={this.props.doFindDonor}
                        onAssign={this.handleAssign}
                        onCancel={this.handleCancelFindDonor}
                    />

                    <FindDsd
                        show={this.state.showFindDsd}
                        centerId={this.props.centerId}
                        search={this.state.search}
                        onSearch={this.props.doFindDsd}
                        onAssign={this.handleAssign}
                        onCancel={this.handleCancelFindDsd}
                    />

                    <MarkDonated
                        show={this.state.markDonated.show}
                        name={this.state.markDonated.data != null ? this.state.markDonated.data.fullName : ''}
                        closeLoopManualConfirmTypes={this.state.closeLoopManualConfirmTypes}
                        onMarkDonated={this.handleMarkDonated}
                        onCancel={this.handleCancelMarkDonated}
                    />
                </DonorSearchProvider>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        center: appState.app.center,
        donorSearch: appState.donorSearch
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        doSearch: (centerId, firstName, lastName, alias, email, dateOfBirth) => {
            return dispatch(DonorSearchActionCreators.doSearch(centerId, firstName, lastName, alias, email, dateOfBirth));
        },
        doCreate: (
            centerId, identifier, registrationId, donorId, donorShieldDirectId, watrRequestId, donorFollowUpId,
            links, firstName, lastName, address, city, state, postalCode, phone, email, birthDate, registrationDate, donationDate,
            donorType, alias, hasNutcracker, sendInvite
        ) => {
            return dispatch(DonorSearchActionCreators.doCreate(
                centerId, identifier, registrationId, donorId, donorShieldDirectId, watrRequestId, donorFollowUpId,
                links, firstName, lastName, address, city, state, postalCode, phone, email, birthDate, registrationDate,
                donationDate, donorType, alias, hasNutcracker, sendInvite));
        },
        doFindDash: (centerId, search) => {
            return dispatch(DonorSearchActionCreators.doFindDash(centerId, search));
        },
        doFindDonor: (centerId, search) => {
            return dispatch(DonorSearchActionCreators.doFindDonor(centerId, search));
        },
        doFindDsd: (centerId, search) => {
            return dispatch(DonorSearchActionCreators.doFindDsd(centerId, search));
        },
        doAssign: (item, type) => {
            return dispatch(DonorSearchActionCreators.doAssign(item, type));
        },
        existsByAlias: (centerId, alias) => {
            return dispatch(DonorSearchActionCreators.existsByAlias(centerId, alias));
        },
        markDonated: (identifier, dashRegistrationId, donationDate, donationType) => {
            return dispatch(DonorSearchActionCreators.markDonated(identifier, dashRegistrationId, donationDate, donationType));
        },
        getLookupData: (centerId) => {
            return dispatch(DonorSearchActionCreators.getLookupData(centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorSearch);